import "../Static Files/styles/Tour Details/tourdetails.css";
import detailimage from "../Static Files/Images/TourDetail/271d2c88-city-35286-177952d9d40.jpg";
import calendar from "../Static Files/Images/TourDetail/Calendar 128x128.png";
import bed from "../Static Files/Images/TourDetail/Bed 128x128.png";
import moon from "../Static Files/Images/TourDetail/Moon 128x128.png";
import person from "../Static Files/Images/TourDetail/Person 128x128.png";
import placeholder from "../Static Files/Images/TourDetail/Placeholder 128x128.png";
import { useDispatch, useSelector } from "react-redux";
import { getTour } from "../slices/tourSlice";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import SendRequestModal from "../Components/sendRequestModal";
import Loading from "../Components/Loading";
import ErrorPage from "../Components/ErrorPage";
import Success from "../Components/success";
import translation from "../locales";

const TourDetails = () => {
  const dispatch = useDispatch();
  const { selectedTour, status, error } = useSelector((state) => state.tours);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [languages, setLanguage] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentPicture, setCurrentPicture] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const { slug } = useParams();
  const location = useLocation();
  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";

  useEffect(() => {
    dispatch(getTour(slug));
  }, [dispatch, slug]);

  useEffect(() => {
    if (selectedTour) {
      setStartDate(formatDate(new Date(selectedTour.startDate)));
      setEndDate(formatDate(new Date(selectedTour.endDate)));
      if (selectedTour.language.includes(",")) {
        setLanguage(selectedTour.language.split(","));
      }
      console.log(selectedTour);
    }
  }, [selectedTour]);

  const formatDate = (date) => {
    return date.toLocaleDateString("numeric", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });
  };

  if (status === "loading") {
    return <Loading />;
  }

  if (status === "failed") {
    return <ErrorPage />;
  }

  if (!selectedTour) {
    return <div>No tour details available</div>;
  }

  const modalOpen = () => {
    setOpenModal(true);
  };

  const modalClose = () => {
    setOpenModal(false);
  };

  const formatPhoneNumber = (phone) => {
    const cleanPhone = phone.startsWith("0") ? phone.slice(1) : phone;
    const operator = cleanPhone.slice(0, 2);
    const part1 = cleanPhone.slice(2, 5);
    const part2 = cleanPhone.slice(5, 7);
    const part3 = cleanPhone.slice(7);

    return `+994 (${operator}) ${part1} ${part2} ${part3}`;
  };

  const getWhatsAppLink = (phone) => {
    if (!phone) return "#"; // Əgər nömrə yoxdursa, boş link

    const cleanPhone = phone.startsWith("0") ? phone.slice(1) : phone;
    return `https://wa.me/994${cleanPhone}`;
  };

  return (
    <>
      <main>
        <div className={openModal ? "page-overlay" : ""}>
          <section
            style={{
              background: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)), url(${selectedTour.headerImageUrl})`,
            }}
            className="tourdetails-hero"
          ></section>

          <section className="tour-detail-section">
            <div className="section-header">
              <h1>{selectedTour.title}</h1>
              <div className="date-div">
                {selectedTour.isPrivate === true ? (
                  <div>sexsi tur</div>
                ) : (
                  <div>{translation[currentLang].tourdetailspackage}</div>
                )}
                {startDate ? (
                  <h4>
                    {translation[currentLang].tourdetailsstartdate}{" "}
                    {startDate.split("T")[0]}
                  </h4>
                ) : (
                  <h4>{translation[currentLang].loading}</h4>
                )}
                {endDate ? (
                  <h4>
                    {translation[currentLang].tourdetailsenddate}{" "}
                    {endDate.split("T")[0]}
                  </h4>
                ) : (
                  <h4>{translation[currentLang].loading}</h4>
                )}
              </div>
            </div>

            <div className="section-body">
              <div className="tour-details-div">
                <div className="picture-div">
                  <div className="pictures-slide-list">
                    <ul>
                      {selectedTour.tourGalleries.length > 0 ? (
                        selectedTour.tourGalleries.map((gallery) => {
                          return (
                            <li
                              onClick={() =>
                                setCurrentPicture(gallery.imageUrl)
                              }
                            >
                              <img src={gallery.imageUrl} alt="#" />
                            </li>
                          );
                        })
                      ) : (
                        <li></li>
                      )}
                    </ul>
                  </div>
                  <div className="selected-image-div">
                    <img
                      src={
                        currentPicture != null
                          ? currentPicture
                          : selectedTour.headerImageUrl
                      }
                      alt="#"
                    />
                  </div>
                  <div className="forResponsive">
                    <div className="price-div">
                      {selectedTour.isSpecialOffer === true ? (
                        <div className="special-offer">
                          {translation[currentLang].specialoffer}
                        </div>
                      ) : selectedTour.hasDiscount === true ? (
                        <div className="special-offer">
                          {translation[currentLang].discountpackage}
                        </div>
                      ) : (
                        <div className="special-offer">
                          {translation[currentLang].standartpackage}
                        </div>
                      )}
                      <div className="phone-div">
                        <i class="fa-solid fa-phone"></i>
                        <h2>
                          {translation[currentLang].tourdetailonline}
                          {selectedTour?.phonenumber &&
                            formatPhoneNumber(selectedTour.phonenumber)}
                        </h2>
                      </div>
                      <div className="price-info">
                        <h1>
                          From {selectedTour.currency === "USD" && "$"}
                          {selectedTour.currency === "EUR" && "€"}
                          {selectedTour.currency === "AZN" && "₼"}
                          {selectedTour.discountPrice}{" "}
                          <h6 className="discount-price">
                            {selectedTour.price}
                          </h6>
                          <span>
                            {" "}
                            {translation[currentLang].tourdetailperperson}
                          </span>
                        </h1>
                        <h2 className="priceinfo-h2">
                          {translation[currentLang].tourdetaillowest}
                        </h2>
                      </div>
                    </div>
                    <div className="travelers-div">
                      <h1>
                        {translation[currentLang].tourdetaildateandtravelers}
                      </h1>
                      <ul>
                        <li>
                          <img src={calendar} alt="calendar" />
                          <h3>
                            {translation[currentLang].tourdetailsstartdate}{" "}
                            {startDate}
                          </h3>
                        </li>
                        <li>
                          <img src={calendar} alt="person" />
                          <h3>
                            {translation[currentLang].tourdetailsenddate} :{" "}
                            {endDate}
                          </h3>
                        </li>
                        <li>
                          <img src={moon} alt="moon" />
                          <h3>{selectedTour.duration}</h3>
                        </li>
                        <li>
                          <img src={placeholder} alt="destination" />
                          {selectedTour.isMultipleTour ? (
                            <h3>
                              {selectedTour.countries.split(",").length}{" "}
                              {translation[currentLang].city}
                            </h3>
                          ) : (
                            <h3>1 {translation[currentLang].city}</h3>
                          )}
                        </li>
                        {/* <li>
                          <img src={bed} alt="bed" />
                          <h3>Rhea Silvia Luxury Navona</h3>
                        </li> */}
                      </ul>
                      <a
                        onClick={() => modalOpen(true)}
                        className="send-button"
                        href="#"
                      >
                        {translation[currentLang].tourdetailsend}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="texts-div">
                  <h1>{translation[currentLang].tourdetailabouttour}</h1>
                  <h3 style={{ color: "#ff6010" }}>{selectedTour.country}</h3>
                  <p>{selectedTour.description}</p>

                  <h2>Hotel</h2>
                  <ul>
                    {selectedTour.hotels.map((hotel) => {
                      return (
                        <li>
                          {hotel.name} - {hotel.price}
                        </li>
                      );
                    })}
                  </ul>
                  <h2>{translation[currentLang].tourdetaillanguages}</h2>
                  <ul className="language-list">
                    {languages.map((language) => {
                      return <li>{language}</li>;
                    })}
                  </ul>
                  <h2>{translation[currentLang].tourdetailincludefeatures}</h2>
                  <ul>
                    {selectedTour.includedFeatures.map((feature) => {
                      return <li>{feature.name}</li>;
                    })}
                  </ul>
                  <h2>{translation[currentLang].tourdetailexcludefeatures}</h2>
                  <ul>
                    {selectedTour.excludedFeatures.map((feature) => {
                      return <li>{feature.name}</li>;
                    })}
                  </ul>
                  <div className="learn-more">
                    <a
                      target="_blank"
                      href={getWhatsAppLink(selectedTour?.phonenumber)}
                    >
                      {translation[currentLang].aboutuslearnmorea}
                    </a>
                    <div className="phone-number">
                      <h2>
                        {translation[currentLang].aboutusformoreinformation}
                      </h2>
                      <p>
                        {selectedTour?.phonenumber &&
                          formatPhoneNumber(selectedTour.phonenumber)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="check-avialibility-div">
                <div className="detail-price-div">
                  {selectedTour.isSpecialOffer === true ? (
                    <div className="special-offer">
                      {translation[currentLang].specialoffer}
                    </div>
                  ) : selectedTour.hasDiscount === true ? (
                    <div className="special-offer">
                      {translation[currentLang].discountpackage}
                    </div>
                  ) : (
                    <div className="special-offer">
                      {translation[currentLang].standartpackage}
                    </div>
                  )}

                  <div className="phone-div">
                    <i class="fa-solid fa-phone"></i>
                    <h2>
                      {translation[currentLang].tourdetailonline}
                      {selectedTour?.phonenumber &&
                        formatPhoneNumber(selectedTour.phonenumber)}
                    </h2>
                  </div>
                  <div className="price-info">
                    {selectedTour.hasDiscount ? (
                      <h1>
                        From ${selectedTour.discountPrice}{" "}
                        <h6 className="discount-price">{selectedTour.price}</h6>
                        <span>
                          {translation[currentLang].tourdetailperperson}
                        </span>
                      </h1>
                    ) : (
                      <h1>
                        From {selectedTour.currency === "USD" && "$"}
                        {selectedTour.currency === "EUR" && "€"}
                        {selectedTour.currency === "AZN" && "₼"}
                        {selectedTour.price}{" "}
                        <span>
                          {translation[currentLang].tourdetailperperson}
                        </span>
                      </h1>
                    )}
                    <h2>{translation[currentLang].tourdetaillowest}</h2>
                  </div>
                </div>
                <div className="travelers-div">
                  <h1>{translation[currentLang].tourdetaildateandtravelers}</h1>
                  <ul>
                    <li>
                      <img src={calendar} alt="calendar" />
                      <h3>
                        {translation[currentLang].tourdetailsstartdate}{" "}
                        {startDate}
                      </h3>
                    </li>
                    <li>
                      <img src={calendar} alt="person" />
                      <h3>
                        {translation[currentLang].tourdetailsenddate} {endDate}
                      </h3>
                    </li>
                    <li>
                      <img src={moon} alt="moon" />
                      <h3>{selectedTour.duration}</h3>
                    </li>
                    <li>
                      <img src={placeholder} alt="destination" />
                      {selectedTour.isMultipleTour ? (
                        <h3>
                          {selectedTour.countries.split(",").length}{" "}
                          {translation[currentLang].city}
                        </h3>
                      ) : (
                        <h3>1 {translation[currentLang].city}</h3>
                      )}
                    </li>
                    {/* <li>
                      <img src={bed} alt="bed" />
                      <h3>Rhea Silvia Luxury Navona</h3>
                    </li> */}
                  </ul>
                  <a
                    onClick={() => modalOpen(true)}
                    className="send-button"
                    href="#"
                  >
                    {translation[currentLang].tourdetailsend}
                  </a>
                </div>
              </div>
            </div>

            <SendRequestModal
              tour_id={selectedTour.id}
              isOpen={openModal}
              onClose={() => setOpenModal(false)}
            ></SendRequestModal>
          </section>
        </div>
      </main>
    </>
  );
};

export default TourDetails;
